import { Button, Result } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as Error404Svg } from '../../resources/images/404.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from './ErrorPage.module.scss';
import HeadMetadata from '../../services/HeadMetadata';

const ErrorPage: React.FC = () => {
    return (
        <>
            <HeadMetadata titleKey="errors.404.meta.title" />
            <Result
                icon={<Icon component={Error404Svg} className={styles.image} />}
                title={<FormattedMessage id="errors.404.title" tagName="h1" />}
                subTitle={<FormattedMessage id="errors.404.description" tagName="p" />}
                extra={
                    <Link to="/">
                        <Button type="primary" size="large">
                            <FormattedMessage id="errors.404.back" tagName="span" />
                        </Button>
                    </Link>
                }
                className={styles.result}
            />
        </>
    );
};
export default ErrorPage;
